// @flow

import React from 'react';
import { Typography, Button, Link } from '@material-ui/core/';

import './style.css';

function MobileSignInButton() {
    return (
        <Typography component="div" >
            <Link color="inherit" href="/signin">
                <Button
                    variant="outlined"
                    color="primary"
                    className="mobile-signin-button"
                >
                    SIGN IN
                </Button>
            </Link>
        </Typography>
    );
}

export default MobileSignInButton;
